import React, { useState, useEffect } from "react";
import styled from "styled-components";

interface stylingProps {
  readonly marginRight?: boolean;
}

interface AutismProps {
  readonly isAutism?: boolean;
}

const Block = styled.div<stylingProps>`
  margin-right: ${(props) => props.marginRight && "1rem"};

  @media (max-width: 1024px) {
    margin-right: ${(props) => props.marginRight && "0.5rem"};
  }

  @media (max-width: 768px) {
    margin-right: 0rem;
    margin-bottom: 1rem;
    width: 80vw;
  }

  @media (max-width: 456px) {
    width: 337px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 240px;
  object-fit: cover;

  @media (max-width: 1024px) {
    width: 100%;
    height: 187.43px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 226px;
  }
`;

const ImageVertical = styled.img<AutismProps>`
  width: 100%;
  height: auto;

  @media (max-width: 1024px) {
    width: 100%;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 81vw;
    height: 285px;
    object-fit: cover;
  }

  @media (max-width: 456px) {
    width: ${(props) => (props.isAutism ? "343px" : "337px")};
  }
`;

const TitleBlock = styled.div`
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: -0.5rem;
  color: white;

  p {
    font-size: 32px;
    line-height: 38.4px;
    letter-spacing: -1%;
  }

  @media (max-width: 1024px) {
    height: 88px;

    p {
      font-size: 24px;
      line-height: 28.8px;
    }
  }

  @media (max-width: 768px) {
    height: 69px;

    p {
      font-size: 20px;
      line-height: 24px;
    }
  }
`;

const TitleBlock2 = styled.div<AutismProps>`
  height: 122px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: -0.5rem;
  color: white;

  h5 {
    font-weight: 600;
    font-size: 18px;
    line-height: 140%;
    text-align: center;
    letter-spacing: -0.01em;
    margin-top: 36px;
  }

  h6 {
    font-weight: 500;
    font-size: 18px;
    line-height: 140%;
    text-align: center;
    letter-spacing: -0.01em;
    margin-top: 10px;
    margin-bottom: 29px;
  }

  @media (max-width: 1024px) {
    height: 110px;

    h5 {
      font-size: 18px;
      line-height: 140%;
      letter-spacing: -0.01em;
    }

    h6 {
      font-size: 16px;
      line-height: 140%;
      letter-spacing: -0.01em;
    }
  }

  @media (max-width: 768px) {
    width: 80.6vw;
    height: 88px;

    h5 {
      font-size: 24px;
      line-height: 110%;
      margin-top: 17px;
    }

    h6 {
      font-weight: 100;
      font-size: 16px;
      line-height: 140%;
      margin-top: 9px;
      margin-bottom: 17px;
    }
  }

  @media (max-width: 456px) {
    width: ${(props) => (props.isAutism ? "343px" : "337px")};
  }
`;

interface Props {
  titleColor?: string;
  name?: string;
  title?: string;
  photo?: string;
  marginRight?: boolean;
  isProfile?: boolean;
  isAutism?: boolean;
}

const ThreePhotosBlock: React.FC<Props> = ({
  titleColor,
  name,
  title,
  photo,
  marginRight,
  isProfile,
  isAutism,
}) => {
  return (
    <Block marginRight={marginRight}>
      {!isProfile ? (
        <>
          <Image alt={name} src={photo} />
          <TitleBlock style={{ backgroundColor: titleColor }}>
            <p>{name}</p>
          </TitleBlock>
        </>
      ) : (
        <div>
          <ImageVertical alt={name} src={photo} isAutism={isAutism} />
          <TitleBlock2
            style={{ backgroundColor: titleColor }}
            isAutism={isAutism}
          >
            <h5>{name}</h5>
            <h6>{title}</h6>
          </TitleBlock2>
        </div>
      )}
    </Block>
  );
};

export default ThreePhotosBlock;
